/**
 * Central Gemini model IDs for premium and routine workloads.
 *
 * Premium default: gemini-4-argon (GA 2026-10-13). Flash remains
 * gemini-3.8-flash so extraction/OCR and other selected routine work keep
 * their existing tier. Document matching deliberately uses the Pro default.
 *
 * Argon is available at Vertex global/us/eu; this application selects global
 * through geminiLocations.ts, without changing older regional model routes.
 * Source: https://docs.cloud.google.com/gemini-enterprise-agent-platform/models/gemini/4-argon
 *
 * Override using GEMINI_PRO_MODEL / GEMINI_FLASH_MODEL. The next Cloud Build
 * deploy sets both explicitly, so cloudbuild.yaml substitutions and these
 * compiled defaults must agree for a durable change. Browser defaults are
 * compiled; a server-only env override does not rebuild the browser bundle.
 *
 * getBestModel retains its runtime-unavailable chain to gemini-2.5-pro and
 * older configured preferences. Direct callers of these constants do not
 * inherit that resolver. Capacity fallback remains bounded and per call.
 *
 * Cost telemetry uses conservative Argon standard pricing ($4/$20 per 1M),
 * without the temporary 50% credit through 2026-11-30. Thinking tokens count
 * as output; estimates are not invoices or proof of runtime compatibility.
 * Source: https://cloud.google.com/gemini-enterprise-agent-platform/generative-ai/pricing
 *
 * A successful reachability probe does not establish report quality. Keep
 * the production-path golden, provenance, grounding and release gates.
 */
export const GEMINI_PRO_MODEL =
  (typeof process !== 'undefined' && process.env?.GEMINI_PRO_MODEL) || 'gemini-4-argon';

export const GEMINI_FLASH_MODEL =
  (typeof process !== 'undefined' && process.env?.GEMINI_FLASH_MODEL) || 'gemini-3.8-flash';
